<div class="sidebar included">
    <app-sidebar-header [title]="'whatsIncludedSidebars.general.title.whatsIncluded' | ibeadmin | async"></app-sidebar-header>
    <div *ngIf="isLoading" class="container">
        <app-loading></app-loading>
    </div>

    <div *ngIf="!isLoading" class="sidebar__body sl--scrollable" #sidebar__body>
        <div class="sidebar-flight" *ngFor="let flight of pack; let x = index" [id]="'flight-' + flight.idFlight">
            <div class="sidebar-flight-header">
                <app-flight-route class="app-flight-route--clean" [flight]="flight"></app-flight-route>
            </div>
            <div class="sidebar-flight-extras">
                <ul class="body">
                    <li *ngFor="let ancillary of features[x]; let i = index" class="extras-feature brand__feature" [ngClass]="INDRA_featureType(ancillary)" (click)="INDRA_handleTicketConditionsClick(flight, ancillary, x)">
                        <app-svg [ngClass]="['extras-feature__icon']" svg="icons.svg#{{ancillary.icon || 'general--plus'}}" aria-hidden="true" [alt]="ancillary.label + ' icon'"></app-svg>

                        <div class="extras-feature__label feature__label">
                            <span *ngIf="ancillary.code === MILES_ANCILLARY_CODE">
								{{ ancillary.amountLabel ? ancillary.amountLabel + ' ' + (ancillary.labelTranslationKey | ibeadmin: 'sync') : (ancillary.labelTranslationKey | ibeadmin: 'sync')}}
							</span>
                            <span *ngIf="ancillary.code === CHECKED_BAG_ANCILLARY_CODE">
								{{ ancillary.amountLabel ? ancillary.amountLabel + ' x ' + (ancillary.labelTranslationKey | ibeadmin: 'sync') : (ancillary.labelTranslationKey | ibeadmin: 'sync')}}
							</span>
                            <span *ngIf="ancillary.code !== MILES_ANCILLARY_CODE && ancillary.code !== CHECKED_BAG_ANCILLARY_CODE">{{ ancillary.labelTranslationKey | ibeadmin: 'sync'}}</span>
                            <span *ngIf="ancillary.description && ancillary.code !== 'BA_MILES'" class="muted-light">
								{{ ancillary.description | ibeadmin: 'sync' }}
							</span>
                        </div>
                        <!--
						<app-svg *ngIf="INDRA_featureIsAdded(ancillary)" class="right check general" [svg]="TAP_getIcon()" alt='is included'></app-svg>
						-->
                        <app-svg *ngIf="INDRA_featureIsAdded(ancillary)" class="right check general" svg="sprite.svg#flight--brand-checked" alt='is included'></app-svg>
                        <p *ngIf="INDRA_featureIsAvailable(ancillary)" class="feature__price">
                            {{'ancillaries.texts.chargeable' | ibeadmin: 'sync'}}

                            <!-- display ancillaries with prices as 'Chargeable' only  -->
                            <!-- <span class="feature__price--prefix">
								{{ 'whatsIncludedSidebars.general.texts.from' | ibeadmin: 'sync' }}
							</span> 
							{{INDRA_featurePrice(ancillary) + INDRA_getCurrency(ancillary) | indracurrency}} -->
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</div>